import { InputSwitch } from 'primereact/inputswitch';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { widges } from '../Config/const';
import * as proyectAction from '../store/actions/proyectAction';
import AADService from './Azure/AADService';

class Portada extends Component {
  constructor(props) {
    super(props);

    this.state = {
      authenticated: null,
      userName: null,
      name: null,
      given_name: null,
      roles: null,
      isWriter: null,
      isContributor: null,
      key: true,
      token: null,
      mapa: true,
      video: true,
      weather: true,
      energy: true,
      perfRatio: true,
      roi: true,
      energyRvE: true,
      retornoOper: true,
      radiacion: true,
      valueMapa: 'On',
      valueVideo: 'On',
      valueWeather: 'On',
      valueEnergy: 'On',
      valueRoi: 'On',
      valuePerformanceRatio: 'On',
      valueRetorno: 'On',
      valueEnergyRvE: 'On',
      valueRadiacion: 'On',
      options: ['Off', 'On'],
      widges: widges,
    };

    this.AzureADService = new AADService();
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  async componentDidMount() {
    if (this.props.global.widgesVisibles !== null) {
      this.setState({ widges: this.props.global.widgesVisibles });
    }
    this.datosUsuario();
    await this.AzureADService.acquireToken();
    //this.setState({key:!this.state.key, token: a});
    this.isAuthenticated();
    this.props.setProyectPlantaVisible(false);
    this.props.setBreadCrumb({});
  }

  datosUsuario() {
    const user = this.props.global.user;
    if (user !== undefined && user !== null) {
      this.setState({
        userName: user.userName,
        name: user.name,
        given_name: user.given_name,
        family_name: user.family_name,
        roles: user.roles,
        isWriter: user.isWriter,
        isContributor: user.isContributor,
        token: user.token,
      });
    }
  }
  isAuthenticated() {
    if (
      !this.AzureADService.loggedIn() ||
      this.AzureADService.getToken() === null
    ) {
      this.AzureADService.acquireToken();
      //this.setState({key:!this.state.key});
    }
  }
  setMapaValue(e) {
    this.setState({ valueMapa: e.value });
  }
  setVariableValue(e) {
    let temp = [];
    if (e.value === null) {
      alert('Seleccione un valor');
    }
    // console.log(e.value);
    this.state.widges.forEach(function (posicion, indice) {
      if (posicion.id === [e.target.id][0]) {
        temp.push({
          id: posicion.id,
          nombre: posicion.nombre,
          value: e.value,
          widge: posicion.widge,
          valor: posicion.valor,
        });
      } else {
        temp.push(posicion);
      }
    });
    this.setState({ widges: temp });
    this.setState({ [e.target.id]: e.value });
    this.props.setWidgesVisibles(temp);
  }

  setValue(e) {
    let temp = [];
    this.state.widges.forEach((posicion, indice) => {
      if (posicion.widge === [e.target.id][0]) {
        temp.push({
          id: posicion.id,
          nombre: posicion.nombre,
          value: e.value,
          widge: posicion.widge,
          valor: !posicion.valor,
        });
      } else {
        temp.push(posicion);
      }
    });
    /*this.state.widges.map(function(posicion, indice){
            if(posicion.widge===[e.target.id][0]){
                temp.push({id:posicion.id, nombre:posicion.nombre, value: e.value, widge: posicion.widge, valor: !posicion.valor});
            }else{
                temp.push(posicion);
            }
        })*/
    this.setState({ widges: temp });
    this.props.setWidgesVisibles(temp);
  }

  render() {
    // console.log(this.state.widges);
    const { t } = this.props;
    const administrarWidges = () => {
      return this.state.widges.map((widgetInfo, index) => (
        <tr key={widgetInfo.nombre} className="p-col-12 p-md-4 floatLeft">
          <td className="p-col-12 p-md-9">{t(widgetInfo.nombre)}</td>
          <td className="p-col-12 p-md-3">
            <InputSwitch
              id={widgetInfo.widge}
              checked={widgetInfo.valor}
              onChange={e => this.setValue(e)}
            />
          </td>
        </tr>
      ));
    };
    return (
      <div className="p-grid" key={this.state.key}>
        <div className="p-col-12">
          <div className="card p-col-12 p-md-12 ">
            <img
              className="width100"
              src="assets/layout/images/Imagen_index.png"
              alt=""
            ></img>
          </div>

          <div className="card p-col-12 p-md-12">
            <div>
              {t('Seleccione los cards que desea ver')}
              <table>
                <tbody>{administrarWidges()}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = rootReducer => {
  return { global: rootReducer.proyect };
};
export default connect(
  mapStateToProps,
  proyectAction,
)(withTranslation('translations')(Portada));
